<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-with-heading" id="dedication">
<div class="heading heading-with-title heading-without-image" id="dedication-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For their invaluable contributions to my understanding of El Paso, West Texas, and southeastern New Mexico, I would like to thank the <i>El Paso Times</i>, the <i>Desert Candle</i>, the El Paso Museum of History, the Hueco Tanks State Historic Site, the Museum and Missile Park at White Sands Missile Range, and many more, particularly the good residents of El Paso themselves. To these people, and others including Ginjer Buchanan, Shane Staley, and Kevin J. Anderson and the great crew at WordFire, I offer my greatest appreciation.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width dedication-content">For Marcy and our family, with love.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6cf5b8be